"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-video-play viewbox="0 0 24 24"><circle cx=12 cy=12 r=12 fill=#fff></circle><path d="M8 17.26V6.74a1 1 0 011.5-.86l9 5.26a1 1 0 010 1.72l-9 5.26a1 1 0 01-1.5-.86z" fill=#111820></path></symbol>';
};